import { Upload, message, Button, Image } from "antd";
import { PlusOutlined } from "@ant-design/icons";

export default function PartnersImageUploader({ image_url, setImageUrl }) {
  const beforeUpload = async (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Faqat rasm fayllari qabul qilinadi!");
      return false;
    }
    return true;
  };

  const handleChange = async (info) => {
    if (info.file.status === 'done') {
      setImageUrl(info.file.originFileObj); // Store the file object
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      <Upload
        name="image_url"  // Must match backend expectation
        listType="picture-card"
        showUploadList={false}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        accept="image/*"
        customRequest={async ({ file, onSuccess, onError }) => {
          try {
            // Just store the file, we'll upload with form submission
            onSuccess();
          } catch (error) {
            onError(error);
          }
        }}
      >
        {image_url ? (
          <img
            src={typeof image_url === 'string' ? image_url : URL.createObjectURL(image_url)}
            alt="uploaded"
            style={{ width: "100%", maxHeight: "100%" }}
          />
        ) : (
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Rasm yuklash</div>
          </div>
        )}
      </Upload>

      {image_url && (
        <Button
          danger
          type="text"
          onClick={() => setImageUrl("")}
          style={{ marginTop: 8 }}
        >
          Rasmni o'chirish
        </Button>
      )}
    </div>
  );
}